/** @jsx jsx */
import { jsx } from '@emotion/core'
//import cmsUtils from '../../cms/utils/cmsUtils';
import utils from '../../utils';
//import style from './style';
import { useAuth } from '../../auth/index'
import { LoginAdmin } from 'components/customAuth/controls/login/loginAdmin';
import { useRouter, SiteLink } from 'components';

export function AdminLogin(props){
    const item = props.item;
    const cmsOption = props.cmsOption || {};
    const cssClass = utils.classNames('cms_item', 'login', item.cssClass || item.anchorName || '');
    const _useAusth = useAuth();
    const router = useRouter();
    
    return(
        <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
            {
                cmsOption.isCmsEdit ?
                <pre style={{fontSize: '12px', margin:'5px', padding: '10px', background:'#eee', border: '1px solid #ccc'}}>
                    <b> Admin Login Item </b>
                </pre> :
                (_useAusth.sessionV2 && !_useAusth.sessionV2.expired() ?
                    <div style={{textAlign:'center'}}>
                        <button className="btn btn-primary" type="button" onClick={()=>{
                            _useAusth.signoutAdmin().then(user => {
                                router.push('/login/admin')
                            });
                        }}>Log out</button>
                    </div> :
                    <div>
                        <LoginAdmin />
                        <div style={{maxWidth:'600px',margin:'auto',marginTop:'1rem'}}>
                            <SiteLink to = '/auth/forgot-password'>
                                Forgot Password?
                            </SiteLink>
                        </div>
                    </div>
                )
            }
        </div>
    )
}